<template>
  <div class="container">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      success-text="刷新成功"
    >
      <div @click.stop="boxClick">
        <div class="topBigBox">
          <div class="firstTopBox">
            <img
              src="../../../static/images/index/logo_white.png"
              class="logoImg"
            />
          </div>
          <div class="secondTopBox">
            <div class="secondItem" @click="toLink('homePage')">
              <div class="iconfont icon-home-fill" />
              <div>我的主页</div>
            </div>
            <div class="secondItem" @click="toLink('myTopic')">
              <div class="iconfont icon-huati"></div>
              <div>我的话题</div>
            </div>
            <div class="secondItem" @click="toLink('myPostcard')">
              <div class="iconfont icon-mingpian-fill"></div>
              <div>我的名片</div>
            </div>
            <div
              class="secondItem"
              v-if="isStore == 0"
              @click="toLink('message')"
            >
              <div class="iconfont icon-email-fill"></div>
              <div>我的消息</div>
            </div>
            <div class="secondItem" v-else @click="toLink('storeShow')">
              <div class="iconfont icon-dianpu"></div>
              <div>我的微展厅</div>
            </div>
          </div>
        </div>

        <div class="bigBox">
          <van-search
            class="searchInner"
            v-model="keyword"
            shape="round"
            background="transparent"
            placeholder="搜索"
            @search="searchHandle"
          />
          <div class="itemBox">
            <van-swipe
              @change="typeSwiperChange"
              style="width: 100%; height: 100%"
              :show-indicators="false"
            >
              <van-swipe-item v-for="(item, index) in itemlist" :key="index">
                <div
                  class="sbts_item"
                  v-for="(inner, innerIndex) in item.children"
                  :key="innerIndex"
                  @click.stop="toItemPath(inner.href, inner.title)"
                >
                  <div
                    class="iconfont"
                    v-if="inner.sdj"
                    :class="inner.icon"
                    style="
                      font-size: 0.95rem;
                      line-height: 1.1rem;
                      margin-bottom: 0px;
                    "
                  ></div>
                  <div class="iconfont" v-else :class="inner.icon"></div>
                  <div v-if="inner.wscz" class="wscz">{{ inner.title }}</div>
                  <div v-else-if="inner.gyz" class="gyz">
                    {{ inner.title }}<span>31th</span>
                  </div>
                  <div v-else>{{ inner.title }}</div>
                </div>
              </van-swipe-item>
            </van-swipe>
            <!--重置小圆点的样式 -->
            <div class="dots">
              <div v-for="(item, index) in itemlist" :key="index">
                <div
                  class="dot"
                  :class="index == itemCurrent ? 'active' : ''"
                ></div>
              </div>
            </div>
          </div>

          <div class="swiper-box" v-if="newsList.length > 0">
            <van-swipe
              :show-indicators="false"
              class="sb_swiper"
              :autoplay="3000"
              @change="newsSwiperChange"
            >
              <van-swipe-item
                v-for="(item, index) in newsList"
                :key="index"
                class="newsItem"
                @click.stop="toPathHandle(item.Path)"
              >
                <van-image
                  :src="item.Img"
                  fit="cotain"
                  class="newsImg"
                ></van-image>
              </van-swipe-item>
            </van-swipe>
            <!--重置小圆点的样式 -->
            <div class="dots">
              <div v-for="(item, index) in newsList" :key="index">
                <div
                  class="dot"
                  :class="index == current ? 'active' : ''"
                ></div>
              </div>
            </div>
          </div>

          <div class="classifyNav">
            <van-tabs
              type="line"
              v-model="active"
              title-inactive-color="#333"
              title-active-color="#d62f2f"
              line-width="32px"
              line-height="5px"
              @change="typeClick"
            >
              <van-tab title="最新"> </van-tab>
              <van-tab title="推荐"> </van-tab>
              <van-tab title="热点"> </van-tab>
              <van-tab title="关注"> </van-tab>
            </van-tabs>
          </div>

          <div class="listBox">
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getListHandle"
            >
              <dynamic-list :list="list" :advert="true"></dynamic-list>
            </van-list>
            <div class="noDataBox" v-if="list.length == 0">
              <span class="iconfont icon-kong"></span>
              <div>什么也没有！</div>
            </div>
          </div>
        </div>

        <!-- 右侧滚动按钮 -->
        <div class="right-box">
          <div class="back" v-if="backTopShow" @click.stop="goTop">
            <img
              src="../../../static/images/icon/up.png"
              style="width: 25px; height: 25px"
            />
          </div>
        </div>

        <!-- 官方活动弹窗 -->
        <div class="firstNews-box official" v-if="officialState">
          <div class="fn_bg" style="background: #000">
            <van-image fit="cover" :src="officialImg"></van-image>
            <div class="fnb_btm" style="background: #e7cb1c; color: #000">
              <router-link
                :to="{ name: 'specificActDetail', query: { sid: 8 } }"
                >点击进入</router-link
              >
            </div>
          </div>
          <div class="fn_close" @click="officialState = false">
            <span class="iconfont icon-clear"></span>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <FooterTab ref="childData"></FooterTab>
  </div>
</template>
<script>
import { postList } from "@/api/index";
import { swipeList } from "@/api/online";
import { loginInfo } from "@/api/member";
import { getShareData } from "@/utils/share";
import FooterTab from "@/components/FooterTab";
import DynamicList from "@/components/dynamicList";
import {
  Col,
  Icon,
  Row,
  Search,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  Toast,
  List,
  Overlay,
  Image,
  PullRefresh,
} from "vant";

export default {
  name: "index",
  components: {
    FooterTab,
    Toast,
    "van-search": Search,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-tab": Tab,
    "van-tabs": Tabs,
    "van-row": Row,
    "van-col": Col,
    "van-icon": Icon,
    "van-list": List,
    "van-overlay": Overlay,
    "van-image": Image,
    "van-pull-refresh": PullRefresh,
    DynamicList,
  },
  data() {
    return {
      isStore: 0,

      itemCurrent: 0,
      itemlist: [
        {
          href: "hotBlock",
          icon: "icon-huati1",
          title: "热门话题",
        },
        {
          href: "onlineExhibition",
          icon: "icon-shipin",
          title: "直播",
        },
        {
          href: "dailyNews",
          icon: "icon-zixun",
          title: "新闻资讯",
        },
        {
          href: "lightingIndex",
          sdj: true,
          icon: "icon-sdj",
          title: "神灯奖",
        },
        {
          href: "hotBlock",
          icon: "icon-lightstrade",
          title: "出口网",
        },
        {
          href: "",
          icon: "icon-product",
          title: "找产品",
        },
        {
          href: "",
          icon: "icon-changshang",
          title: "找厂商",
        },
        {
          href: "",
          icon: "icon-cart",
          title: "采购",
        },
        {
          href: "",
          wscz: true,
          icon: "icon-zhu",
          title: "网上参展",
        },
        {
          href: "exhibition",
          gyz: true,
          icon: "icon-gile",
          title: "光亚展",
        },
        {
          href: "industryGuru",
          icon: "icon-quanwei",
          title: "行业大咖",
        },
      ],

      keyword: "",

      current: 0,
      newsList: [],

      active: 1, //0推荐 1热点 2最新 3关注
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      isLoading: false,

      showLayer: false,
      offsetTop: 700,
      backTopShow: false,

      //官方活动
      officialState: false,
      officialImg: "https://files.alighting.com/Cover/official20210526.png",
    };
  },
  methods: {
    //点击其他空白，隐藏发布按钮
    boxClick() {
      this.$refs["childData"].publishBtn = false;
    },

    //轮播切换-自制定点
    typeSwiperChange(index) {
      this.itemCurrent = index;
    },

    //项跳转
    toItemPath(href, title) {
      if (title == "出口网") {
        window.location.href = "https://m.lightstrade.com/";
      } else if (title == "网上参展") {
        window.location.href =
          "https://www.alighting.cn/special/20200812/index.html";
      } else if (title == "采购") {
        this.$router.push({
          path: "/nextTopic",
          query: {
            cid: 12,
          },
        });
      } else {
        this.$router.push({
          path: "/" + href,
        });
      }
    },

    //处理数据
    listCheckHandle(list) {
      var length = list.length;
      var num = Math.ceil(length / 10);
      var newList = [];
      for (var i = 0; i < num; i++) {
        var obj = {};
        obj.children = [];
        list.forEach(function (item, index) {
          var data = {};
          data.icon = item.icon;
          data.href = item.href;
          data.title = item.title;
          data.wscz = item.wscz;
          data.gyz = item.gyz;
          data.sdj = item.sdj;
          if (index < 10) {
            obj.children.push(data);
          }
        });
        newList.push(obj);
        list.splice(0, 10);
      }
      return newList;
    },

    //获取轮播图
    getSwipeList() {
      var data = {
        Type: 294,
      };
      swipeList(data).then((response) => {
        this.newsList = response.Data.List;
      });
    },

    //海报轮播
    newsSwiperChange(index) {
      this.current = index;
    },

    //海报跳转
    toPathHandle(path) {
      if (
        path ==
        "/subpackagelive/pages/onlineExhibitionTopics/onlineExhibitionTopics"
      ) {
        this.$router.push({ path: "/onlineExhibitionTopics" });
      } else if (path == "/pages/topicCenter/details/details?tid=261") {
        this.$router.push({
          path: "/hotTopicDetails",
          query: { hid: 260 },
        });
      } else if (path == "/pages/storeIndex/storeIndex?id=78298") {
        this.$router.push({
          path: "/storeShow",
          query: { mid: 78298 },
        });
      } else if (path == "/subpackageforum/pages/questionnaire/questionnaire") {
      } else if (
        (path = "/subpackagelive/pages/liveDetail/liveDetail?id=1833")
      ) {
      } else if (path == "/pages/memberCenter/homepage/homepage?mid=8632") {
        this.$router.push({
          path: "/homePage",
          query: { mid: 8632 },
        });
      } else {
        window.location.href = path;
      }
    },

    //搜索框
    searchHandle() {
      this.$router.push({
        path: "/allSearch",
        query: { keyword: this.keyword },
      });
    },

    //tab切换
    typeClick(name) {
      this.active = name;
      this.pageIndex = 1;
      this.list = [];
      this.getListHandle();
    },

    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {
        Type:
          that.active == 0
            ? 2
            : that.active == 1
            ? 0
            : that.active == 2
            ? 1
            : 3, //0推荐 1热点 2最新 3关注
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
      };
      postList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //判断滚动条位置
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > this.offsetTop) {
        this.backTopShow = true;
      } else {
        this.backTopShow = false;
      }
    },

    //返回顶部
    goTop() {
      window.scrollTo(0, 0);
    },

    //刷新
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.pageIndex = 1;
        this.keyword = "";
        this.getListHandle();
        this.getSwipeList();
      }, 1000);
    },

    //获取会员登录信息
    getLoginInfo() {
      loginInfo().then((res) => {
        this.isStore = res.Data.StoreId;
      });
    },

    //顶部链接跳转
    toLink(name) {
      var that = this;
      if (localStorage.token != "" && localStorage.token != null) {
        if (name == "homePage") {
          that.$router.push({
            path: "/homePage",
            query: { mid: localStorage.getItem("mid") },
          });
        } else if (name == "myTopic") {
          that.$router.push("/myTopic");
        } else if (name == "myPostcard") {
          that.$router.push("/myPostcard");
        } else if (name == "message") {
          that.$router.push("/message");
        } else if (name == "storeShow") {
          that.$router.push({
            path: "/storeShow",
            query: { mid: localStorage.getItem("mid") },
          });
        } else {
        }
      } else {
        that.Common.showMsg("您还没登录，请登录", function () {
          that.$router.push("/codeLogin");
        });
      }
    },
  },

  created() {
    this.getSwipeList();
    this.$store.commit("setFooterNav", "index");
    if (localStorage.token != "" && localStorage.token != null) {
      this.getLoginInfo();
    }
  },

  mounted() {
    var list = this.listCheckHandle(this.itemlist);
    this.itemlist = list;
    getShareData(
      window.location.href,
      "随时随地了解照明行业动态，这里有你想要认识的人！",
      "",
      "https://files.alighting.com/uploads/202103/20210316104037472802.jpg"
    );
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.container {
  .classifyNav {
    font-size: 15px;
    margin-top: 8px;
    /deep/ [class*="van-hairline"]::after {
      border: none;
    }
    /deep/ .van-tab--active {
      font-weight: bold;
    }
  }
  .topBigBox {
    background-color: #d62f2f;
    .firstTopBox {
      display: flex;
      align-items: center;
      padding-top: 15px;
      .logoImg {
        width: 95px;
        margin: 0 15px;
      }
    }
    .secondTopBox {
      display: flex;
      flex-direction: row;
      padding: 20px 10px 70px 10px;
      .secondItem {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #ffffff;
        .iconfont {
          font-size: 27px;
          margin-bottom: 6px;
        }
      }
    }
  }
  .bigBox {
    background-color: #fff;
    border-radius: 15px 15px 0px 0px;
    margin-top: -30px;
    position: relative;
    .searchInner {
      position: absolute;
      top: -30px;
      left: 8px;
      z-index: 10;
      /deep/.van-search__content {
        width: 330px;
        background-color: #fff;
        box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.2);
      }
    }
    .itemBox {
      position: relative;
      padding: 32px 20px 10px 20px;
      /deep/ .van-swipe-item {
        display: flex;
        flex-wrap: wrap;
      }
      .sbts_item {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .iconfont {
          font-size: 25px;
          color: #d62f2f;
        }
        div {
          &:nth-child(2) {
            font-size: 12px;
            color: #666;
            margin-top: 2px;
          }
        }
        .wscz {
          width: 60px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          background: #d62f2f;
          color: #fff !important;
          border-radius: 10px;
        }

        .gyz {
          width: 48px;
          height: 20px;
          line-height: 20px;
          background: #0a1833;
          border-radius: 10px;
          color: #fff !important;
          text-align: center;
          position: relative;
          span {
            width: 38px;
            height: 18px;
            line-height: 18px;
            background: #d62f2f;
            border: 1px solid #ffffff;
            border-radius: 8px;
            color: #fff;
            font-size: 15px;
            transform: scale(0.5);
            text-align: center;
            position: absolute;
            right: -12px;
            top: -12px;
          }
        }
      }
      .dots {
        display: flex;
        flex-direction: row;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 10px;
        .dot {
          width: 7px;
          height: 3px;
          background: rgba(214, 47, 47, 0.4);
        }
        .active {
          background: rgba(214, 47, 47, 1);
        }
      }
    }

    .swiper-box {
      position: relative;
      width: 335px;
      height: 86px;
      margin: 5px auto 0;
      .sb_swiper {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
        .newsItem {
          width: 100%;
          height: 100%;
          .newsImg {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 5px;
          }
        }
      }
      .dots {
        display: flex;
        flex-direction: row;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 5px;
        .dot {
          width: 3px;
          height: 3px;
          background: rgba(255, 255, 255, 1);
          margin-left: 3px;
          border-radius: 3px;
          &::first-child {
            margin-left: 0px;
          }
        }
        .active {
          width: 10px;
        }
      }
    }
  }
  .right-box {
    position: fixed;
    right: 10px;
    bottom: 75px;
    div {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      border: 1px solid #eee;
      box-shadow: 0px 0px 3px #ddd;
      background-color: #fff;
    }
  }
  .firstNews-box {
    position: fixed;
    z-index: 10002;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .fn_bg {
      width: 320px;
      height: 433px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
      .van-image {
        width: 100%;
        height: 320px;
        display: block;
      }
      .fnb_btm {
        margin: 35px auto 0;
        width: 150px;
        height: 40px;
        background: #c82525;
        border-radius: 20px;
        color: #fff;
        font-size: 15px;
        line-height: 40px;
        text-align: center;
      }
    }
    .fn_close {
      width: 35px;
      margin: 35px auto 0;
      text-align: center;
      .iconfont {
        color: #fff;
        font-size: 32px;
        line-height: 32px;
      }
    }
  }
}
</style> 
